import React from 'react'

const DisplayCard = ({ title,handleDelete,handleEdit }) => {
  return (
    <div className='py-10 px-5 relative rounded-lg shadow-lg bg-blue-500 hover:bg-blue-600 transition-all duration-200 ease-in-out hover:-translate-y-1'>
        <p className='text-white font-semibold text-center text-wrap capitalize'>{title}</p>
        <div className='absolute flex items-center gap-4 top-2 right-4 z-10'>
            <span className='text-white text-lg' onClick={handleEdit} ><i className="fa-solid fa-pen-to-square"></i></span>
            <span className='text-red-500 text-lg' onClick={handleDelete} ><i className="fa-solid fa-trash"></i></span>
        </div>
    </div>
  )
}  

export default DisplayCard